<script>
import { FormWizard, TabContent } from "vue-form-wizard";

import personal_info from "@/components/step-bank-loans/martyr/personal-info";
import istshhad_info from "@/components/step-bank-loans/martyr/istshhad-info";
import loan_info from "@/components/step-bank-loans/martyr/loan-info";
import attachment_info from "@/components/step-bank-loans/martyr/attachment-info";

import { swal } from "../../../helpers/handle_error.js";
import AlertError from "@/components/alert_error";
import MartyrModel from "../../../model/step-bank-loans/martyr";
import BankLoansServices from "../../../services/BankLoans";
import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import unitTestStepBankLoansMartyr from "../../../helpers/unit_test_step_bank_loans_martyr";

import { mapGetters } from "vuex";

export default {
  components: {
    FormWizard,
    TabContent,
    personal_info,
    istshhad_info,
    loan_info,
    attachment_info,
    AlertError,
    "qr-code": VueQRCodeComponent,
  },
  data() {
    return {
      //Page errors.
      errors: [],

      isPrintedInformation: false,
      fullName: "",
      Id: "",
      date: "",
      qrCodeContent: "",
      showAlert: false,

      //sacrificer code.
      code: this.$route.params.code,
      sacrificer: null,
    };
  },
  computed: {
    ...mapGetters("authSacrificer", ["getSacrificer"]),
  },
  methods: {
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    resetForm() {
      this.errors = [];
      swal.close();
    },
    onComplete: function () {
      swal.loading();

      var data = new MartyrModel(
        this.code,
        this.$refs["personal_info"],
        this.$refs["istshhad_info"],
        this.$refs["loan_info"],
        this.$refs["attachment_info"]
      );

      BankLoansServices.addMartyr(data.toFormData())
        .then((response) => {
          this.fullName = response.data.data.fullName;
          this.Id = response.data.data.id;
          this.date = response.data.data.date;

          this.qrCodeContent = JSON.stringify({
            Id: this.Id,
            fullName: this.fullName,
            date: this.date,
          });

          this.isPrintedInformation = true;
          this.resetForm();
        })
        .catch((error) => {
          this.handleError(error);
          swal.close();
        });
    },
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
    // print card
    async printThis() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
  mounted() {
    if (process.env.NODE_ENV == "development") {
      unitTestStepBankLoansMartyr(this.$refs);
    }

    this.sacrificer = this.getSacrificer;
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <!-- Features start -->
    <img class="img-wallpaper" src="@/assets/images/wallpaper2.png" alt="" />
    <section
      class="section"
      id="features"
      style="min-height: calc(100vh - 163px); padding-top: 40px"
    >
      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <a href="/home/index"><h4>منصة امتنان</h4></a>
              <h5>
                <div class="small-title">
                  استمارة اطفاء القروض الحكومية ( الخاصة بالشهداء )
                </div>
              </h5>
            </div>
          </div>
          <div v-if="isPrintedInformation" class="text-center print-cover">
            <div class="card-print con-print text-center" ref="printcontent">
              <h5>استمارة اطفاء القروض الحكومية</h5>
              <p><strong>الاسم :</strong> {{ fullName }}</p>
              <p><strong>تاريخ التقديم :</strong> {{ date }}</p>
              <p><strong>رقم الاستمارة :</strong> {{ Id }}</p>
              <qr-code class="qr-code" :text="qrCodeContent"></qr-code>
              <hr />
              <div class="">
                <p class="mb-1">هيأة الحشد الشعبي</p>
                <p class="mb-0">المديرية العامة للعلاقات والخدمات الاجتماعية</p>
              </div>
            </div>
            <button
              type="button"
              id="btn3"
              @click="printThis"
              class="btn bg-color-blue font-color-white btn-sm mt-2"
            >
              حفظ وصل التسجيل
            </button>
          </div>
          <div v-else class="col-lg-12">
            <div class="mb-5">
              <form-wizard
                color="#556ee6"
                error-color="#a94442"
                step-size="xs"
                back-button-text="السابق"
                next-button-text="التالي"
                finish-button-text="ارسال البيانات"
                @on-complete="onComplete"
              >
                <tab-content
                  title="معلومات الشهيد"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('personal_info')"
                >
                  <personal_info
                    ref="personal_info"
                    @on-validate="mergePartialModels"
                    :sacrificer="sacrificer"
                  ></personal_info>
                </tab-content>
                <tab-content
                  title="معلومات الاستشهاد"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('istshhad_info')"
                >
                  <istshhad_info
                    ref="istshhad_info"
                    @on-validate="mergePartialModels"
                  ></istshhad_info>
                </tab-content>
                <tab-content
                  title="معلومات القروض"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('loan_info')"
                >
                  <loan_info
                    ref="loan_info"
                    @on-validate="mergePartialModels"
                  ></loan_info>
                </tab-content>
                <tab-content
                  title="اضافة المرفقات"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('attachment_info')"
                >
                  <attachment_info
                    ref="attachment_info"
                    @on-validate="mergePartialModels"
                  ></attachment_info>
                </tab-content>

                <tab-content
                  title="ارسال البيانات"
                  icon="mdi mdi-checkbox-marked-circle-outline"
                >
                  <h4 class="my-5 text-center">
                    اضغط على ( ارسال البيانات ) لارسال الاستمارة .
                  </h4>
                </tab-content>
              </form-wizard>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->

    <!-- Footer start -->
    <footer class="landing-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img src="@/assets/images/logo.png" alt height="25" />
            <span class="mx-2">منصة امتنان</span>
          </div>
          <div class="col-md-6">
            <p class="mt-1 text-md-end d-sm-block mb-0">
              {{ new Date().getFullYear() }} © جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer end -->
  </div>
</template>
